module.exports = __webpack_public_path__ + "static/media/attach.89c91762.svg";